import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectAlertMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_ALERT_MESSAGE);
        this.AccountId = -1;
        this.UserId = -1;
        this.InstrumentTradableID = -1;
        this.RouteId = null;
        this.AlertId = -1;
        this.AlertType = null;
        this.AlertCondition = null;
        this.AlertValue = null;
        this.AlertImportance = null;
        this.Date = null;
        this.AlertAfterExecute = null;
        this.AlertAction = null;
        this.AlertNotification = null;
        this.Text = null;
        this.AlertEvent = null;
        this.AlertStatus = null;
        this.IsAllowOTHTrading = null;
        this.OrderPlaceParametrs = null; // Attributes locate in the AlertMessageProcessor.ts
    }
}
